import React, { useState } from "react";
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  Radio,
  Button,
  Checkbox,
  InputNumber,
} from "antd";
import useCommonsService from "../../../../services/useCommonsService";
import LocationPicker from "./LocationPicker";
import useFirmService from "../../../../services/useFirmService";

const AdvertFormSecondPage = ({
  form,
  isAbroad,
  setIsAbroad,
  selectedCityId,
  setSelectedCityId,
  isExperienced,
  setIsExperienced,
  isUseSavedLocation,
  setIsUseSavedLocation,
  saveLocation,
  setSaveLocation,
}) => {
  const {
    useGetAllPositions,
    useGetDepartments,
    useGetAllJobOptions,
    cities,
    useDistricts,
    useGetAllCountries,
    useSchoolTypes,
  } = useCommonsService();
  const { data: jobPositions } = useGetAllPositions();
  const { data: departments } = useGetDepartments();
  const { data: jobOptions } = useGetAllJobOptions();
  const { data: countries } = useGetAllCountries();
  const { data: schoolTypes } = useSchoolTypes();
  const { data: districts } = useDistricts(selectedCityId);

  const { useGetSavedLocation } = useFirmService();
  const { data: savedLocations } = useGetSavedLocation();

  const handleCityChange = (value) => {
    setSelectedCityId(value);
    form.setFieldValue("district", undefined);
  };
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item
            name="departmentId"
            label="İlgili Departman"
            rules={[
              { required: true, message: "Lütfen Zorunlu Alanları Doldurun" },
            ]}>
            <Select
              options={departments}
              style={{ height: 35 }}
              placeholder="Departman Seçin"></Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="positionId"
            label="İlgili Pozisyon"
            rules={[
              { required: true, message: "Lütfen Zorunlu Alanları Doldurun" },
            ]}>
            <Select
              options={jobPositions}
              style={{ height: 35 }}
              placeholder="Pozisyon Seçin"></Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Form.List name="optionIds">
          {() =>
            jobOptions?.map((item, index) => (
              <Col xs={24} sm={12} key={item.label}>
                <Form.Item
                  rules={[
                    {
                      required: item.isRequired,
                      message: "Lütfen zorunlu alanlardan en az bir tane seçin",
                    },
                  ]}
                  name={[index]}
                  label={item.label}>
                  <Select
                    allowClear
                    mode="multiple"
                    options={item.options}
                    style={{ height: 35 }}
                    placeholder={`${item.label} seçin`}
                  />
                </Form.Item>
              </Col>
            ))
          }
        </Form.List>
        <Col span={4}>
          <Form.Item label="Tecrübeli Personel">
            <Checkbox
              checked={isExperienced}
              onChange={(e) => setIsExperienced(e.target.checked)}>
              Tecrübe Arıyorum
            </Checkbox>
          </Form.Item>
        </Col>
        {isExperienced && (
          <Col span={8}>
            <Form.Item name="experienceYear" label="Min Tecrübe ">
              <InputNumber style={{ width: "100%" }} placeholder="Yıl" />
            </Form.Item>
          </Col>
        )}
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="Kayıtlı Adres">
            <Checkbox
              checked={isUseSavedLocation}
              onChange={(e) => setIsUseSavedLocation(e.target.checked)}>
              Kayıtlı Adreslerimden Kullanmak İstiyorum
            </Checkbox>
          </Form.Item>
        </Col>
        {isUseSavedLocation && (
          <Col span={16}>
            <Form.Item
              name="savedLocationId"
              label="Kayıtlı Adresler"
              rules={[
                {
                  required: isUseSavedLocation,
                  message: "Lütfen Zorunlu Alanları Doldurun",
                },
              ]}>
              <Select
                // showSearch
                // optionFilterProp="label"
                // filterSort={(optionA, optionB) =>
                //   (optionA?.label ?? "")
                //     .toLowerCase()
                //     .localeCompare((optionB?.label ?? "").toLowerCase())
                // }
                options={savedLocations}
                style={{ height: 35 }}
                placeholder="Kayıtlı Adres Seçiniz"></Select>
            </Form.Item>
          </Col>
        )}
      </Row>
      {!isUseSavedLocation && (
        <>
          {" "}
          <Row gutter={16}>
            {!isAbroad ? (
              <>
                {" "}
                <Col xs={24} sm={10}>
                  <Form.Item
                    name="city"
                    label="Şehir(ler)"
                    rules={[
                      {
                        required: !isAbroad,
                        message: "Lütfen Zorunlu Alanları Doldurun",
                      },
                    ]}>
                    <Select
                      showSearch
                      optionFilterProp="label"
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={cities}
                      onChange={handleCityChange}
                      style={{ height: 35 }}
                      placeholder="Şehir Seçiniz"></Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={10}>
                  <Form.Item name="district" label="İlçe(ler)">
                    <Select
                      options={districts}
                      style={{ height: 35 }}
                      placeholder="İlçe Seçin"></Select>
                  </Form.Item>
                </Col>
              </>
            ) : (
              <Col xs={24} sm={10}>
                <Form.Item
                  name="countryId"
                  label="Ülke"
                  rules={[
                    { required: isAbroad, message: "Lütfen Ülke seçiniz!" },
                  ]}>
                  <Select
                    showSearch
                    optionFilterProp="label"
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={countries}
                    style={{ height: 35 }}
                    placeholder="İlçe Seçin"></Select>
                </Form.Item>
              </Col>
            )}
            <Col xs={24} sm={4}>
              <Form.Item name="district" label="Ülke">
                <Button
                  onClick={() => setIsAbroad(!isAbroad)}
                  style={{ height: 35 }}>
                  {isAbroad
                    ? "Yurtiçi İçin Tıklayınız"
                    : " Yurtdışı İçin Tıklayınız"}
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                name="location"
                label="Adres Konumu"
                rules={[
                  {
                    required: true,
                    message: "Lütfen haritadan konum seçiniz",
                  },
                  {
                    validator: (_, value) => {
                      if (!value?.address) {
                        return Promise.reject("Lütfen adres bilgisini alınız");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}>
                <LocationPicker
                  setSaveLocation={setSaveLocation}
                  saveLocation={saveLocation}
                  initialLocation={
                    form.getFieldValue("location")
                      ? {
                          latitude: form.getFieldValue("location")?.latitude,
                          longitude: form.getFieldValue("location")?.longitude,
                          address: form.getFieldValue("location")?.address,
                        }
                      : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>{" "}
        </>
      )}

      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item
            name="minEducationLevel"
            label="Eğitim Düzeyi (En Az)"
            rules={[
              { required: true, message: "Lütfen Zorunlu Alanları Doldurun" },
            ]}>
            <Select
              options={schoolTypes}
              style={{ height: 35 }}
              placeholder="Eğitim Düzeyi Seçin"></Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col xs={24} sm={12}>
          <Form.Item name="minAge" label="Yaş Aralığı">
            <Input style={{ height: 35 }} placeholder="Minimum Yaş" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item name="maxAge" label=" ">
            <Input style={{ height: 35 }} placeholder="Maksimum Yaş" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default AdvertFormSecondPage;
